// methods here build URLs for site pages

import utilityService from './utilityService.js'

export default {
    mixins: [utilityService],
    methods: {
        amalgamationDraftingAvailable(shaftsCount, treadlesCount, warpThreadsCount, weftThreadsCount) {
            // console.log('amalgamationDraftingAvailable, shaftsCount: ' + shaftsCount + ', treadlesCount: ' + treadlesCount + ', warpThreadsCount: ' + warpThreadsCount + ', weftThreadsCount: ' + weftThreadsCount)
            let currentThreads = Math.max(warpThreadsCount, weftThreadsCount)

            let maxAmalgamationTieupSize = 60
            let minAmalgamationTieupSize = 3
            let maxThreads = 400
            let maxSizeFactor = 2000

            // tieup must be square or able to be made square and smaller than 72 for practical amalgamations here
            let amalgamationTieupSize = this.getLeastCommonMultiple(shaftsCount, treadlesCount)
            let sizeFactor = amalgamationTieupSize * currentThreads
            // console.log('amalgamation tieup size: ' + amalgamationTieupSize + '', 'currentThreads: ' + currentThreads + ', sizeFactor: ' + sizeFactor)
            return (amalgamationTieupSize >= minAmalgamationTieupSize) && (amalgamationTieupSize <= maxAmalgamationTieupSize) && (currentThreads <= maxThreads) && (sizeFactor < maxSizeFactor)
        },

        // Note: iPad safari has a max canvas size of 16777216
        //
        // Allowing for a max cell size of 30 and a little extra for treadles/shafts/tiueup,
        // this works out to a maximum allowable thread count of 707 x 707
        //
        // because 707 * 707 * 30 = 14995470, with a little left over for the shafts/treadles/tieup

        profileDraftingAvailable(warpThreadsCount, weftThreadsCount) {
            let threadsTotal = warpThreadsCount * weftThreadsCount
            // this.timelog('profile Total threads: ' + threadsTotal)
            return threadsTotal < (707 * 707) / 10
        },

        draftEditingAvailable(warpThreadsCount, weftThreadsCount) {
            let threadsTotal = warpThreadsCount * weftThreadsCount
            // this.timelog('draftEditing Total threads: ' + threadsTotal)
            return threadsTotal <= (707 * 707)
        },

        draftRepeatingAvailable(draft) {
            return true
        }
    }
}
